module.exports = __webpack_public_path__ + "img/send_code.13da8745.png";